import React from 'react';
const CreditContext = React.createContext();
export default CreditContext;